import { Injectable } from '@angular/core';

export interface NotificationI {
  id: number;
  text: string;
  type: 'error' | 'warning' | 'info' | 'success';
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  notificationList: NotificationI[] = [];
  constructor() {}

  showInfo(text: string) {
    let id = Math.random();
    this.notificationList.push({
      id,
      text,
      type: 'info',
    });
    setTimeout(() => {
      this.notificationList = this.notificationList.filter((el) => el.id != id);
    }, 3000);
  }

  showSuccess(text: string) {
    let id = Math.random();
    this.notificationList.push({
      id,
      text,
      type: 'success',
    });
    setTimeout(() => {
      this.notificationList = this.notificationList.filter((el) => el.id != id);
    }, 3000);
  }

  showWarning(text: string) {
    let id = Math.random();
    this.notificationList.push({
      id,
      text,
      type: 'warning',
    });
    setTimeout(() => {
      this.notificationList = this.notificationList.filter((el) => el.id != id);
    }, 3000);
  }

  showError(text: string, delay:number=3000) {
    let id = Math.random();
    this.notificationList.push({
      id,
      text,
      type: 'error',
    });
    setTimeout(() => {
      this.notificationList = this.notificationList.filter((el) => el.id != id);
    }, delay);
  }

  hide(id: number) {
    this.notificationList = this.notificationList.filter((el) => el.id != id);
  }
}
